<div class="page-body">
  <div class="page-display-area">
    <!-- Header Section -->
    <div>
      <div class="mainActivityType">{{activity.mainActivityType}}</div>
      <div class="activityName">{{activity.name}}</div>
      
      <div class="activity-meta">
        <div class="provider-info">
          <span>Activity provider: </span>
          <a href="">{{storeName}}</a>
        </div>
        <div class="rating-favorites">
          @if (activity.reviews && activity.reviews > 0) {
            <div class="ratingSystem">
              <app-product-ratings [productRating]=activity.rating></app-product-ratings>
              <span>{{activity.rating}} / 5</span>
              <span>{{reviews}}</span>
            </div>
          }
          <button mat-button color="primary" aria-label="Add to favorites">
            Add to favorites
            <mat-icon>favorite</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Images Section -->
    <div class="images-section">
      @if (hasValidPictures && pictures && pictures.length > 0) {
        <!-- Desktop Image Grid (hidden on mobile) -->
        <div class="imageBox">
          @if (pictures[0] && pictures[0].url) {
            <img class="displayLargePic clickable-image" [src]="pictures[0].url" [alt]="pictures[0].description || activity.name" (error)="handleImageError($event, pictures[0], 0)" (click)="openImageCarousel(0)">
          }
          <div style="display: flex; flex-direction: column; gap: 8px; width: 33.33%;">
            @if (pictures[1] && pictures[1].url) {
              <img class="displayMediumPic clickable-image" [src]="pictures[1].url" [alt]="pictures[1].description || activity.name" (error)="handleImageError($event, pictures[1], 1)" (click)="openImageCarousel(1)">
            }
            <div style="display: flex; gap: 8px;">
              @if (pictures[2] && pictures[2].url) {
                <img class="displaySmallPic clickable-image" [src]="pictures[2].url" [alt]="pictures[2].description || activity.name" (error)="handleImageError($event, pictures[2], 2)" (click)="openImageCarousel(2)">
              }
              @if (pictures[3] && pictures[3].url) {
                <img class="displaySmallPic clickable-image" [src]="pictures[3].url" [alt]="pictures[3].description || activity.name" (error)="handleImageError($event, pictures[3], 3)" (click)="openImageCarousel(3)">
              }
            </div>
          </div>
        </div>
        
        <!-- Mobile Carousel (visible on mobile only, hidden on desktop) -->
        @if (pictures && pictures.length > 0) {
          <ngb-carousel class="carouselBox">
            @for (pic of pictures; track pic._uniqueTrack || pic.id || ($index + '-' + pic.url) || $index) {
              @if (pic && pic.url && pic.url.trim() !== '') {
                <ng-template ngbSlide>
                  <div style="width: 100%; display: flex; justify-content: center;">
                    <img class="images-frame clickable-image" [src]="pic.url" [alt]="pic.description || activity.name" (error)="handleImageError($event, pic, $index)" (click)="openImageCarousel($index)">
                  </div>
                </ng-template>
              }
            }
          </ngb-carousel>
        }
      } @else {
        <div class="images-coming-soon-banner">
          <span>Images coming soon</span>
        </div>
      }
    </div>

    <!-- Activity Details Section -->
    <div class="bookingData">
      <div class="description-section">
        <p>{{activity.description}}</p>
        
        <div>
          <h2 class="activitydescription">About this activity</h2>
          <!-- <app-amenity *ngFor="let amenity of activity.amenities"
            [amenity]="amenity"
            iconSize="150px"
          ></app-amenity> -->
        </div>
      </div>

      <div>
        <h2 class="activitydescription">Experience</h2>
        <div>
          <div class="experience">
            <div class="experienceInfo">Highlights</div>
            <ul class="item-left-padding">
              @for (highlight of activity.highlights; track highlight) {
                <li>{{highlight}}</li>
              }
            </ul>
          </div>
          <hr>
          <div class="experience">
            <div class="experienceInfo">Full description</div>
            <div class="experience-content">{{activity.fullDescription}}</div>
          </div>
          <hr>
          <div class="experience">
            <div class="experienceInfo">Includes</div>
            <div class="experience-content">
              <!-- Includes content will go here -->
            </div>
          </div>
          <hr>
          <div class="experience">
            <div class="experienceInfo">Not suitable for</div>
            <ul class="item-left-padding">
              @for (item of activity.notSuitable; track item) {
                <li>{{item}}</li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Booking Section -->
    <div>
      <mat-card class="price-box">
                <mat-card-header>
                  Activity Booking Details
                </mat-card-header>
                <mat-card-content>
                  <form class="flex flex-column align-content-center" [formGroup]="bookActivityForm">
                    <div class="flex flex-column">
                      <div class="flex">
                        <div style="width: 300px;">
                          <mat-calendar [(selected)]="dateSelected" [dateFilter]="unavailableFilter" (selectedChange)="dateSelection()"></mat-calendar>
                        </div>
                        <div class="ms-3 w-100">
                          <mat-card class="w-100">
                            <mat-card-header>Pick a time</mat-card-header>
                            <mat-card-content>
                              @if (availabilityI != null && availabilityI.timeSlots && availabilityI.timeSlots.length > 0) {
                                <mat-selection-list (selectionChange)="timePicker()" formControlName="timeSlotOptions" #slots [multiple]="true">
                                  @for (option of availabilityI.timeSlots; track $index; let ind = $index) {
                                    <div class="flex" style="align-items: center; margin-bottom: 8px;">
                                      <div style="flex: 1; min-width: 200px;">
                                        <mat-list-option [value]="ind">
                                          {{option.timeSlot}}
                                        </mat-list-option>
                                      </div>
                                      <mat-form-field appearance="outline" style="flex: 1; min-width: 200px;">
                                        <mat-label>Slots (Max: {{option.personSlots}})</mat-label>
                                        <input matInput type="number" min="0" [max]="option.personSlots" [formControlName]="timeSlotsPrefix + (ind+1)" (change)="takeSlot()">
                                      </mat-form-field>
                                    </div>
                                  }
                                </mat-selection-list>
                              } @else {
                                <div class="flex justify-content-center" style="padding: 20px;">
                                  <p>Please select a date to see available times</p>
                                </div>
                              }
                            </mat-card-content>
                          </mat-card>
                        </div>
                      </div>
                      <div class="flex mt-3 w-100 justify-content-between">
                        <mat-card class="flex w-100">
                          <mat-card-content class="p-2">
                            <div class=" flex justify-content-between pb-2">
                              <div class="w-25">Total:</div><div class="w-25 pt-1 me-2 text-end">{{totalCurrentCost | currency:'USD':'symbol': '1.2-2'}}</div>
                              <button mat-raised-button  color="primary" type="submit" (click)="showPaymentInfo()">
                                PAY
                              </button>
                            </div>
                            @if (timeToPay) {
                              <div class="flex justify-content-between">
                                <div class="flex flex-column" [formGroup]="paymentElementForm">
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Name" formControlName="name" />
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Email" type="email" formControlName="email" />
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Phone" type="tel" formControlName="phone" />
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Address" formControlName="address" />
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="ZIP Code" formControlName="zipcode" />
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="City" formControlName="city" />
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Hotel / referral code" formControlName="referralCode" />
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Hotel name" formControlName="hotelName" />
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <input matInput placeholder="Room number" formControlName="hotelRoomNumber" />
                                  </mat-form-field>
                                </div>
                                <div class="stripe-payment-container">
                                  @if (elementsOptions.clientSecret) {
                                    <ngx-stripe-elements
                                      [stripe]="stripe"
                                      [elementsOptions]="elementsOptions">
                                      <ngx-stripe-payment [options]="paymentElementOptions"></ngx-stripe-payment>
                                    </ngx-stripe-elements>
                                  } @else {
                                    <div class="flex justify-content-center" style="padding: 20px;">
                                      <p>Initializing payment...</p>
                                    </div>
                                  }
                                </div>
                            </div>
                          }
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </div>

                          <div class="me-5 mt-1" #tooltip="matTooltip" matTooltip="Login to save and view booking history!" [matTooltipDisabled]="signedIn">
                            @if (timeToPay && elementsOptions.clientSecret) {
                              <button 
                                mat-raised-button 
                                color="primary" 
                                (click)="pay()"
                                [disabled]="paying() || paymentElementForm.invalid">
                                @if (paying()) {
                                  Processing Payment...
                                } @else {
                                  Complete Payment
                                }
                              </button>
                            } @else {
                              <button mat-raised-button color="primary" (click)="bookActivity()">Book Activity</button>
                            }
                          </div>

                </form>
                <div class="flex spaceBetween">
                  <!-- DISCOUNTS DISABLED - Always show regular price -->
                  <div class="flex flexColumn">
                    <span>From</span>
                    <span class="price-per-person">US$ {{activity.pricePerPerson}}</span>
                    <span>per person</span>
                  </div>
                </div>
                <div class="flex" style="margin-top: 20px;">
                  <img class="reserve-icon-size" src="../../../../assets/icons8-schedule-100.png" alt="">
                  <span>Reserve your spot and pay up front</span>
                </div>
              </mat-card-content>
              <mat-card-footer class="ps-3 pb-3">
                @if (activity.sellOut) {
                  <mat-chip style="background-color: #e90c31;">Likely to sell out</mat-chip>
                }
              </mat-card-footer>
      </mat-card>
    </div>
  </div>
</div>
